import { useEffect, useState } from "react";

import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

import {
  showCategories,
  updateCategories,
} from "../../../../MyApi/sb/categories";

import PageHeader from "../../../../Components/UI/PageHeader";
import EditCategories from "../../../../Components/sb/categories/categoriesUpdate/EditCompanies";
import LoadingSpinner from "../../../../Components/UI/spinner";

const CategoriesUpdate = () => {
  const [name, setName] = useState("");
  const [active, setActive] = useState(1);
  const lang = localStorage.getItem("i18nextLng");
  const [selectedCodeLang, setSelectedCodeLang] = useState(lang);
  const { id } = useParams();
  const { data, isLoading } = useQuery(["showcategory", id,selectedCodeLang], () =>
    showCategories(id,selectedCodeLang)
  );
  const categories = data?.data || [];
  useEffect(() => {
    setName(categories.name);
    setActive(categories.active);
  }, [categories]);

  const mutation = useMutation(
    ["updateCategories", id],
    (postData) => updateCategories(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const handlePostRequest = () => {
    mutation.mutate({
      name,
      active,
      lang_code: selectedCodeLang,
    });
  };
  const onSelectChange = (e) => {
    setSelectedCodeLang(e.target.value);
  };
  const isDisabled = () => {
    return;
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data available</div>;
  }
  return (
    <div>
      <PageHeader
        title="Edit Category"
        showBack={true}
        showSelect
        onSelectChange={onSelectChange}
        saveButton={true}
        isdisbled={isDisabled}
        handlePostRequest={handlePostRequest}
      />
      <EditCategories
        setActive={setActive}
        active={active}
        name={name}
        setName={setName}
      />
    </div>
  );
};

export default CategoriesUpdate;
